// TODO: check
import { ColSize } from "types/generic/types";

export const getColSizeClassNames = ({
  xsColSize,
  smColSize,
  mdColSize,
  lgColSize,
  xlColSize,
}: ColSize) => {
  return {
    [`col${xsColSize ? `-${xsColSize}` : ""}`]: !!xsColSize,
    [`col-sm${smColSize ? `-${smColSize}` : ""}`]: !!smColSize,
    [`col-md${mdColSize ? `-${mdColSize}` : ""}`]: !!mdColSize,
    [`col-lg${lgColSize ? `-${lgColSize}` : ""}`]: !!lgColSize,
    [`col-xl${xlColSize ? `-${xlColSize}` : ""}`]: !!xlColSize,
  };
};
